import { curry, compose, map, keys, prop } from 'ramda';

/**
 * @callback object~filterPredicate
 * @param {String} key
 * @param {Number} keyIndex
 * @param {Array} keyArray
 * @returns {Boolean}
 */

/**
 * Returns a shallow extract of an object.
 * @curry
 * @param {object~filterPredicate} test - The predicate used to filter the object's properties
 * @param {Object} obj - The object to filter
 * @returns {Object}
 */
export const filter = curry((test, obj) =>
  Object.assign.apply(Object, [
    {},
    ...Object.keys(obj)
      .filter(test)
      .map((key) => ({ [key]: obj[key] })),
  ])
);

/**
 * @type {object~filterPredicate}
 */
const search = (key) => (elem) =>
  (typeof elem !== 'string' && key.match(elem)) || elem === key;

/**
 * @param {Array.<String|RegExp>} allowed
 * @returns {function(Object): (Object)}
 */
export const extract = (allowed) => filter((key) => allowed.find(search(key)));

export const json = (obj, lim = 2) => JSON.stringify(obj, null, lim);

export const objectify = curry((attribute, array) =>
  Object.assign({}, ...array.map((a) => ({ [a[attribute]]: a })))
);

/**
 * @param {Object} obj
 * @param {Function} [modifier]
 * @returns {Array.<any>}
 */
export const toArray = (obj, modifier = (res) => res) =>
  compose(
    map((key) => modifier(prop(key, obj), key, obj)),
    keys
  )(obj);
